<template>
    <div class="pb-4 relative">
        <div class="wrapper-input">
            <input type="text"
                :id="inputId"
                class="input-data"
                v-model="content"
                :minlength="inputMinLength"
                :maxlength="inputMaxLength"
                @input="onChange()"
                @focus="onFocus(true)"
                @blur="onFocus(false)">
            <label :for="inputId"
                class="title-label"
                :class="[{'transition-label-no-content': !content && !focusText},
                        {'transition-label-content': content || focusText},
                        ]"
            >{{inputLbl.name}}</label>
        </div>
        <div class="text-error" v-if="!errorInfo.isValid"
             v-show="!errorInfo.isValid">{{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";
import Vue from 'vue';
/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Boolean} isTextOnly (optional) Only text.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputEmail",
    props: {
        // v-model
        value: String,
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        isTextOnly:     { type: Boolean, default: false },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        delimeter:      { type: String, default: '' },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            inputId: '',
            content: this.value,
            inputMinLength: null,
            inputMaxLength: null,
            focusText: false,
        };
    },
    // computed: {
    //     isError: function() {
    //         return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
    //     },
    //     getErrorMsg: function() {
    //         return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
    //             ? this.errorInfo.msg
    //             : '';
    //     },
    // },
    created: function () {
        let randId = Math.floor(Math.random() * 100000);
        this.inputId = 'contact-number-' + randId;

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required && Util.isEmptyStr(this.content)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short
                && (this.content < this.minLength)) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.minLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                if(!Vue.validator.validateEmail(this.content)) {

                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onChange: function () {
            var result = this.content;
            //Remove restrict character.
            result = result.replace(RegxHelper.emoji, '');
            result = RegxHelper.removeThai(result);

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
    },
}
</script>
<style lang="scss" scoped>
   @import "@/style/Input/Input.scss";
</style>
